/**
 * debug - Флаг и хелперы отладочного логирования клиента
 * ======================================================
 *
 * CRA инлайнит process.env.NODE_ENV и process.env.REACT_APP_* на этапе сборки,
 * поэтому IS_DEBUG в production-сборке становится константой false, а мёртвые
 * ветки логирования выпиливает минификатор.
 *
 * Правило: в горячих путях (рендер виджета, каждый ответ API) логируем только
 * ФОРМУ данных (describePayload), а не сам payload — иначе метрики утекают в
 * консоль браузера и жрут память длинной сессии.
 */

export const IS_DEBUG =
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG === 'true';

const MAX_DESCRIBED_KEYS = 8;

/**
 * Короткое описание формы данных без самих значений
 * @param {*} value - Любое значение (ответ API, данные виджета)
 * @returns {string} - Например: "{ data: Array(30), totals: object }"
 */
export function describePayload(value) {
  if (value === null || value === undefined) return String(value);
  if (Array.isArray(value)) return `Array(${value.length})`;
  if (typeof value !== 'object') return typeof value;

  const keys = Object.keys(value);
  const shape = keys.slice(0, MAX_DESCRIBED_KEYS).map((key) => {
    const item = value[key];
    if (Array.isArray(item)) return `${key}: Array(${item.length})`;
    if (item === null) return `${key}: null`;
    return `${key}: ${typeof item}`;
  });

  if (keys.length > MAX_DESCRIBED_KEYS) {
    shape.push(`…+${keys.length - MAX_DESCRIBED_KEYS}`);
  }

  return `{ ${shape.join(', ')} }`;
}

/**
 * console.log только в debug-режиме
 * @param {...*} args - Аргументы для console.log
 * @returns {void}
 */
export function debugLog(...args) {
  if (IS_DEBUG) {
    console.log(...args);
  }
}
